import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Certificado} from "../../model/Certificado";
import {environment} from "../../environments/environment.prod";
import {OAuthService} from "angular-oauth2-oidc";

@Injectable()
export class CertificadoProvider {

  apiCertificado: string = "/certifier/v1/certificate";

  constructor(public http: HttpClient, private oauthService: OAuthService) {
  }

  getAllCertificadoById(certificados: Certificado[]) {
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiLogin + this.apiCertificado,
        {headers:{Authorization: this.oauthService.authorizationHeader()}})
        .subscribe((result: Certificado[]) => {
            resolve(result);
          },
          (error) => {
            reject(error);
          });
    });
  }

  getCertificadoById(idEmpresa: number, cpfCNPJ: string) {
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiLogin + this.apiCertificado + '/' + idEmpresa + '/' + cpfCNPJ,
        {headers:{Authorization: this.oauthService.authorizationHeader()}})
        .subscribe((result: Certificado[]) => {
            resolve(result);
          },
          (error) => {
            reject(error);
          });
    });
  }

  postCertificado(certificado: Certificado) {
    return new Promise((resolve, reject) => {
      this.http.post(environment.apiLogin + this.apiCertificado, certificado,
        {headers:{Authorization: this.oauthService.authorizationHeader()}})
        .subscribe((result: Certificado[]) => {
            resolve(result);
          },
          (error) => {
            reject(error);
          });
    });
  }

  putCertificado(certificado: Certificado) {
    return new Promise((resolve, reject) => {
      this.http.put(environment.apiLogin + this.apiCertificado, certificado,
        {headers:{Authorization: this.oauthService.authorizationHeader()}})
        .subscribe((result: Certificado[]) => {
            resolve(result);
          },
          (error) => {
            reject(error);
          });
    });
  }

  delCertificado(idEmpresa: number, cpfCNPJ: string) {
    return new Promise((resolve, reject) => {
      this.http.delete(environment.apiLogin + this.apiCertificado + '/' + idEmpresa + '/' + cpfCNPJ,
        {headers:{Authorization: this.oauthService.authorizationHeader()}})
        .subscribe((result: Certificado[]) => {
            resolve(result);
          },
          (error) => {
            reject(error);
          });
    });
  }

  getCertificateLogs(companyId, userId){
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiLogin + this.apiCertificado + '/logs/' + companyId + '/' + userId,
        {headers:{Authorization: this.oauthService.authorizationHeader()}})
        .subscribe((result ) => {
            resolve(result);
          },
          (error) => {
            reject(error);
          });
    });
  }

  getESConfig(companyId) {
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiLogin + this.apiCertificado + '/es-config/' + companyId,
        {headers: {Authorization: this.oauthService.authorizationHeader()}})
        .subscribe((result) => {
            resolve(result);
          },
          (error) => {
            reject(error);
          });
    });
  }

  postESConfig(companyId, esConfig) {
    return new Promise((resolve, reject) => {
      this.http.post(environment.apiLogin + this.apiCertificado + '/es-config/' + companyId, esConfig,
        {headers: {Authorization: this.oauthService.authorizationHeader()}})
        .subscribe((result) => {
            resolve(result);
          },
          (error) => {
            reject(error);
          });
    });
  }

}
